import { ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProcessRunStatus } from '@econtractor/types';
import ProcessStatusBadge from './ProcessStatusBadge';

interface ProcessRunProgressProps {
    status: ProcessRunStatus;
    done: number;
    total: number;
}

const ProcessRunProgress = ({ status, done, total }: ProcessRunProgressProps) => {
    const { t } = useTranslation(['Tasks']);
    const safeTotal = Math.max(0, Number(total) || 0);
    const safeDone = Math.max(0, Math.min(Number(done) || 0, safeTotal));
    const showMeter = status === 'active' && safeTotal > 0;
    const percent = safeTotal > 0 ? Math.round((safeDone / safeTotal) * 100) : 0;

    return (
        <div className="process-run-status">
            <div className="d-flex align-items-center gap-2">
                <ProcessStatusBadge status={status} />
                {showMeter ? (
                    <span className="process-run-progress__value text-muted fs-12 ms-auto">
                        {t('processRuns.progressValue', { done: safeDone, total: safeTotal })}
                    </span>
                ) : null}
            </div>
            {showMeter ? (
                <ProgressBar
                    now={percent}
                    variant={safeDone === safeTotal ? 'success' : 'primary'}
                    className="process-run-progress__bar mt-1"
                    aria-label={t('processRuns.progressAria', { done: safeDone, total: safeTotal })}
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                />
            ) : null}
        </div>
    );
};

export default ProcessRunProgress;
